import { useEffect } from "react";
import styles from "../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { ToastContainer } from "react-toastify";

const ProfileDetailsModal = ({ fetchedBorrowerDetails, closeProfileModal }) => {
  console.log(fetchedBorrowerDetails, "fb")
  const [formattedDob, setFormattedDob] = useState(null);

  const formatDate = async (dateString) => {
    console.log(dateString);
    if (dateString && typeof dateString === 'string') {
      
      const dateOnly = dateString.includes('T') ? dateString.split('T')[0] : dateString;
      
      const dateParts = dateOnly.split('-');
      if (dateParts.length === 3 && dateParts[0].length === 4) {
        return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
      }
    }
    return 'N/A';
  
  }

  useEffect(() => {
    if (fetchedBorrowerDetails) {
      const { borrower_dob } = fetchedBorrowerDetails;
      
      if (borrower_dob) {
        formatDate(borrower_dob).then((formattedDate) => {
          setFormattedDob(formattedDate);
        });
      }
    }
  }, [fetchedBorrowerDetails]);

  return (
    <>
      <ToastContainer />
      <div className={styles.profileDetailsModal}>
        <div
          className={styles.profileDetailsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeProfileModal()}
        >
          <div className={styles.profileDetailsModalContent}>
            <h3>
              Personal Details - {[
                fetchedBorrowerDetails.borrower_firstname,
                fetchedBorrowerDetails.borrower_middlename,
                fetchedBorrowerDetails.borrower_lastname,
              ].filter(Boolean).join(" ")}
            </h3>

            <table className={styles.detailsTable}>
              <tbody>
                {[
                  ["Title:", fetchedBorrowerDetails.borrower_title],
                  ["Gender:", fetchedBorrowerDetails.borrower_gender],
                  ["First Name:", fetchedBorrowerDetails.borrower_firstname],
                  ["Middle Name:", fetchedBorrowerDetails.borrower_middlename],
                  ["Last Name:", fetchedBorrowerDetails.borrower_lastname],
                  ["Date Of Birth:", formattedDob],
                  ["Educational Qualification:", fetchedBorrowerDetails.borrower_education],
                  ["Father Name:", fetchedBorrowerDetails.borrower_fathername],
                  ["Mother's Maiden Name:", fetchedBorrowerDetails.borrower_mother_maiden],
                  ["Mother Tongue:", fetchedBorrowerDetails.borrower_motherTongue],
                  ["Category:", fetchedBorrowerDetails.borrower_category],
                  ["Religion:", fetchedBorrowerDetails.borrower_religion],
                  ["Voter ID:", fetchedBorrowerDetails.borrower_voter_no],
                ].map(([label, value], index) => (
                  <tr key={index}>
                    <td className={styles.labelCell}>{label}</td>
                    <td className={styles.valueCell}>{value || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className={styles.CloseIcon} onClick={closeProfileModal}>
              <CloseIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default ProfileDetailsModal;
